import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { isAddressValid } from '../../../../../../util/account';
import Button from '../../../../../../components/global/Button';
import StopIcon from '../../../../../../components/icons/StopIcon';
import WarningIcon from '../../../../../../components/icons/WarningIcon';
import CheckboxIcon from '../../../../../../components/icons/CheckboxIcon';
import { getInlineAddressDescription } from '../../../../../../apps/pro/views/AccountAddressBook/AccountShutterbugAddressBookTable/helpers';
import ExternalShippingAddressFormModal from '../../../../../../components/global/ExternalShippingAddressForm/modal';

const propTypes = {
  row: PropTypes.shape({
    name: PropTypes.string,
    address_line_1: PropTypes.string,
    address_line_2: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    post_code: PropTypes.string,
    country: PropTypes.string,
    phone_number: PropTypes.string,
    email_address: PropTypes.string,
    date_of_birth: PropTypes.string,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

const ContactSpreadsheetInvalidRow = ({ row, onChange, onDelete }) => {
  const [addressEdit, setAddressEdit] = useState(false);
  const isRowValid = isAddressValid(row);

  return (
    <Fragment>
      <tr>
        <td>
          {isRowValid ? <CheckboxIcon size={16} /> : <WarningIcon size={16} />}
        </td>
        <td className="text-left">
          <p className="mb-0">
            {row.name}
            <br />
            {getInlineAddressDescription(row)}
          </p>
        </td>
        <td>{row.phone_number ?? '-'}</td>
        <td>
          {row.date_of_birth
            ? moment(row.date_of_birth).format('MM-DD-YYYY')
            : '-'}
        </td>
        <td>
          <div className="d-flex justify-content-end">
            <Button
              btnSize="xs"
              btnStyle="white"
              onClick={() => setAddressEdit(true)}
              className="btn-edit-address-book-row"
            >
              {!isRowValid && <WarningIcon size={12} className="mr-1" />}
              Edit
            </Button>
            <Button
              btnSize="xs"
              btnStyle="white"
              onClick={onDelete}
              className="btn-edit-address-book-row ml-1"
            >
              <StopIcon size="12" />
            </Button>
          </div>
        </td>
      </tr>

      {addressEdit && (
        <ExternalShippingAddressFormModal
          forceOpen
          address={row}
          onClose={() => setAddressEdit(false)}
          onSubmit={address => {
            onChange(address);
            setAddressEdit(false);
          }}
        />
      )}
    </Fragment>
  );
};

ContactSpreadsheetInvalidRow.propTypes = propTypes;

export default ContactSpreadsheetInvalidRow;
